import type { PaymentRow } from "./personDetailTypes";
import { PAYMENT_AMOUNT_TOLERANCE, PAYMENT_DISPLAY_STATUS } from "./personDetailValues";

/** Zahlung ist änderbar; sonst öffnet der Zeilenklick sie nur zum Ansehen. */
export function canEditPersonPayment(payment: PaymentRow): boolean {
  const amount = Number(payment.amount || 0);
  const voidableRemaining = payment.voidableRemaining != null ? Number(payment.voidableRemaining) : amount;
  return !payment.allocations?.length
    && amount > 0
    && !payment.reversesPaymentId
    && !payment.isCancelled
    && payment.isReversal !== true
    && voidableRemaining >= amount - PAYMENT_AMOUNT_TOLERANCE
    && String(payment.displayStatus || "") !== PAYMENT_DISPLAY_STATUS.reversed;
}
